export default "__VITE_ASSET__Zw3DIQ5m__"